module.exports = __webpack_public_path__ + "static/media/Having a Good Day.88a9d174.jpg";